(function () {
  'use strict';

  angular
    .module('crewStandByReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewStandByReport', {
        url: '/crew-standby-report',
        views : {
          'crewStandByReportView' : {
            templateUrl: 'crew-standby-report/views/crew-standby-report.tpl.html',
            controller: 'CrewStandByReportCtrl',
            controllerAs: 'crewStandByReport'
          }
        }
      });
  }
}());
